<template>
  <div>
    <div class="form-row mt-1">
      <div class="col-4">&nbsp;</div>
      <div class="form-group col-4">{{ $t('general.day') }}</div>
      <div class="form-group col-4">{{ $t('general.night') }}</div>
    </div>
    <div v-for="(day, i) in days" :key="day" class="form-row">
      <div class="col-4 text-right pt-1">
        {{
          $moment()
            .day(i + 1)
            .format('dddd')
        }}
      </div>
      <div class="form-group col-4">
        <field :form="form" :name="fieldName(day, '.day')" layout="empty" />
      </div>
      <div class="form-group col-4">
        <field :form="form" :name="fieldName(day, '.night')" layout="empty" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PerDayPrices',

  props: {
    form: {
      required: true,
      type: Object,
    },
    fieldNameTemplate: {
      type: String,
      default: 'pricing.days.{day}.night',
    },
  },

  data() {
    return {
      days: [
        'monday',
        'tuesday',
        'wednesday',
        'thursday',
        'friday',
        'saturday',
        'sunday',
      ],
    }
  },
  methods: {
    fieldName(day, suffix) {
      return this.fieldNameTemplate.replace('{day}', day) + suffix
    },
  },
}
</script>

<style scoped></style>
